"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const react_1 = require("react");
const audio_player_1 = require("./audio-player");
exports.AudioButton = (0, react_1.memo)(({ audioUrl, onPlayStateChange }) => {
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const audioRef = (0, react_1.useRef)(null);
    const handleAudioButtonClick = (0, react_1.useCallback)(() => {
        var _a, _b;
        if (isPlaying) {
            (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        }
        else {
            (_b = audioRef.current) === null || _b === void 0 ? void 0 : _b.play();
        }
    }, [isPlaying]);
    const handlePlayStateChange = (0, react_1.useCallback)((playing) => {
        setIsPlaying(playing);
        onPlayStateChange === null || onPlayStateChange === void 0 ? void 0 : onPlayStateChange(playing);
    }, [onPlayStateChange]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: handleAudioButtonClick, children: isPlaying ? (0, jsx_runtime_1.jsx)(icons_material_1.VolumeUp, { color: "primary" }) : (0, jsx_runtime_1.jsx)(icons_material_1.VolumeUp, {}) }), (0, jsx_runtime_1.jsx)(audio_player_1.AudioPlayer, { src: audioUrl, ref: audioRef, onPlayStateChange: handlePlayStateChange })] }));
});
exports.AudioButton.displayName = "AudioButton";
